import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

// Initialize Sanity client
export const sanityClient = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: process.env.REACT_APP_SANITY_API_VERSION || '2024-11-21',
  useCdn: true, // Set to false for fresh data, true for cached (better performance)
});

// Helper for generating optimized image URLs from Sanity
const builder = imageUrlBuilder(sanityClient);

export const urlFor = source => {
  return builder.image(source);
};

export default sanityClient;
